import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function FGWListAdministration({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/administration/creating-removing-endpoints'}
                onClick={handleDrawerToggle}
                secondary={'Creating and Removing Endpoints'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/administration/installing-configuring-flight-gateway'}
                onClick={handleDrawerToggle}
                secondary={'Installing and Configuring Gateways'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/administration/activate-upgrade-gateway'}
                onClick={handleDrawerToggle}
                secondary={'Activating and Upgrading Gateways'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/administration/users'}
                onClick={handleDrawerToggle}
                secondary={'Adding and Removing Users'}
            />
        </List>
    );
}

FGWListAdministration.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default FGWListAdministration;
